import React from "react";
import { 
  useNavigate,
} from "react-router-dom";
import Modal from 'react-modal';
import { FaArrowLeft } from "react-icons/fa";

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    backgroundColor: 'rgb(238, 238, 238)',
    borderRadius: 0,
    position: 'fixed',
    padding: window.innerWidth > 640 ? 0 : '0 0 72px 0',
    top: '0',
    left: window.innerWidth > 640 ? '0px' : '0px',
    width: window.innerWidth > 640 ? 'calc(100% - 0px)' : '100%',
    height: '100%',
    zIndex: '99',
    border: 0,
  }
}

export default function PageAsModal({children}) {
  const navigate = useNavigate();

  return (
    <Modal
      portalClassName="fadein-modal"
      ariaHideApp={false}
      isOpen={true}
      onRequestClose={()=> navigate(-1)}
      style={modalStyles}
      closeTimeoutMS={500}
    >
      <div className="page-as-modal">
        <button
          className="btn btn-outline-light back-btn"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
        </button>
        {children}
      </div>
    </Modal>
  );
}
